import { render } from "./ProjectContents.vue?vue&type=template&id=4e82adfa"
import script from "./ProjectContents.vue?vue&type=script&lang=js"
export * from "./ProjectContents.vue?vue&type=script&lang=js"

import "./ProjectContents.vue?vue&type=style&index=0&id=4e82adfa&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__